<template>
  <AppPageContainer :showNav="true" :clean="true" :background="'calendar'">
    <div class="affiliate-dashboard">
      <div class="affiliate-dashboard--header">
        <h1>Affiliate Dashboard</h1>
      </div>
    </div>
  </AppPageContainer>
</template>

<script>
import AppPageContainer from "../../components/AppPageContainer.vue";

export default {
  components: {
    AppPageContainer,
  },
};
</script>

<style></style>
